import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FileHandle } from '../directive/drag-and-drop.directive';
import { MediaDialogHandlerComponent } from '../media/media-dialog-handler/media-dialog-handler.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef} from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CommentsService } from '../service/comments.service';
import { ImageCompressionService } from '../service/image-compression.service';
import { UploadService } from '../service/upload.service';
import { DragFileBrowseData } from '../shared/media';
import { SettingsService } from '../service/settings.service';
import { TaskTemplateFieldDialogComponent } from '../worktask/worktask-template-field-dialog/worktask-template-field-dialog.component';
import { BillboardImgEditFormComponent } from '../widgets/edit-dialog/billboard-img-edit-form/billboard-img-edit-form.component';
import { CalltoactionEditFormComponent } from '../widgets/edit-dialog/calltoaction-edit-form/calltoaction-edit-form.component';
import { ImageEditFormComponent } from '../widgets/edit-dialog/image-edit-form/image-edit-form.component';
import { BillboardVdEditFormComponent } from '../widgets/edit-dialog/billboard-vd-edit-form/billboard-vd-edit-form.component';
import { TextEditFormComponent } from '../widgets/edit-dialog/text-edit-form/text-edit-form.component';
import { VideoEditFormComponent } from '../widgets/edit-dialog/video-edit-form/video-edit-form.component';
import { ImagesEditFormComponent } from '../widgets/edit-dialog/images-edit-form/images-edit-form.component';
import { ProductRegistrationEditFormComponent } from '../widgets/edit-dialog/product-registration-edit-form/product-registration-edit-form.component';
import { SplashVideoEditFormComponent } from '../widgets/edit-dialog/splash-video-edit-form/splash-video-edit-form.component';
import { VideosEditFormComponent } from '../widgets/edit-dialog/videos-edit-form/videos-edit-form.component';

@Component({
    selector: '[app-drag-file-browse-ui]',
    templateUrl: './drag-file-browse-ui.component.html',
    styleUrls: ['./drag-file-browse-ui.component.css'],
    standalone: false
})

export class DragFileBrowseUIComponent {
  @Input('app-drag-file-browse-ui') data:DragFileBrowseData;
  @Output() returnChanges = new EventEmitter<DragFileBrowseData>()
  
  addUrl: boolean
  urlData: any
  url: any
  changes: boolean
  noUrl: boolean
  newImage: any
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  files: FileHandle[] = []
  dragFileBrowseForm!:FormGroup
  maxAllowedSizeInBytes:number
  maxSizeInBytes:number
  returnUrlType = undefined
  contextLicenseFree = false

  constructor(public dialogRef: MatDialogRef<DragFileBrowseUIComponent>,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private commentService:CommentsService,
    private imageCompressionService: ImageCompressionService,
    private translate: TranslateService,
    private uploadService: UploadService,
    private settingsService:SettingsService){}

  ngOnInit(): void {
    this.settingsService.contextLicenseFreePublisher$.subscribe( value => this.contextLicenseFree = value)
  }

  ngOnChanges() {
    const {calledFrom, calledFromData, enableDragDrop, enableBrowse, enableMedia, enableEnterUrl,enableMultipleDragDrop, 
      supportedFileTypes,supportedFileAccept, maxSizeInBytes,maxAllowedSizeInBytes, 
      returnSupportUrl,returnUrlData, enterUrl, returnUrlType} = this.data

      this.maxSizeInBytes = maxSizeInBytes
      this.maxAllowedSizeInBytes = maxAllowedSizeInBytes

    this.dragFileBrowseForm = this.fb.group({
      calledFrom: [calledFrom],
      calledFromData: [calledFromData],
      enableDragDrop:[enableDragDrop],
      enableBrowse: [enableBrowse],
      enableMedia:[enableMedia],
      enableEnterUrl:[enableEnterUrl],
      enableMultipleDragDrop: [enableMultipleDragDrop],
      supportedFileTypes:[supportedFileTypes],
      supportedFileAccept:[supportedFileAccept],
      maxSizeInBytes:[maxSizeInBytes],
      maxAllowedSizeInBytes:[maxAllowedSizeInBytes],
      returnSupportUrl:[returnSupportUrl],
      returnUrlData:[returnUrlData],
      enterUrl:[enterUrl],
      returnUrlType: [returnUrlType]
    })

    this.dragFileBrowseForm.valueChanges.subscribe( value => {
      this.returnChanges.emit(value)
    })
  }
  typeURL(){
    this.urlData = './../../assets/img/default.jpg'
    this.dragFileBrowseForm.patchValue({returnUrlData: this.urlData, enterUrl: true})
  }

  browserFromMediaFolder(){
    let dialogRef= this.dialog.open(MediaDialogHandlerComponent, {
      data: {
        supportedFiles: this.data.supportedFileTypes
      },
      width: '630px',
      maxWidth: '100vw'
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result[0]){
        const url = result[1]
        const supportUrl = result[2]
        
        this.url = url
        this.urlData = supportUrl
        this.changes = true
        this.dragFileBrowseForm.patchValue({ returnSupportUrl: this.url , returnUrlData: this.urlData, returnUrlType: 'media'})
        this.noUrl = false
      }
    });
  }

  readURL(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async (e) => {
        if (e.target) {
          const urlNew = e.target.result as string;
          this.returnUrlType = 'browse'
          if (urlNew) {
            this.urlData = urlNew;
            if(this.data.calledFrom == BillboardVdEditFormComponent || this.data.calledFrom == SplashVideoEditFormComponent || this.data.calledFrom == VideoEditFormComponent)
              this.compressVideoFileAndUpload(file, this.data.calledFromData.widgetNumber,this.urlData)
            else
            this.compressFileAndUpload(file, this.data.calledFromData.widgetNumber,this.urlData)
          }
        }
      };
    }
  }  
  
  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }

  async filesDropped(files: FileHandle[]): Promise<void> {
    this.files = files;
    if(this.data.enableDragDrop){
      if(this.data.enableMultipleDragDrop){
        files.forEach( (file:any, index:any)=> {
          const urlData = file.url;
          if(this.data.supportedFileTypes.includes(file.file.type))
          this.compressFileAndUpload(file.file, index,urlData)
          else{
            const message = this.translate.instant("SnackBarConstants.UNSUPPORTED_FILE")
            this.commentService.addSnackBar.emit(message)
          }
        })
        this.returnUrlType = 'dragDrop'
  
      }else{
        const fileToUpload = files[0].file;
        const urlData = files[0].url;
        this.returnUrlType = 'dragDrop'
  
        if(this.data.calledFrom == BillboardVdEditFormComponent || this.data.calledFrom == SplashVideoEditFormComponent || this.data.calledFrom == VideoEditFormComponent || this.data.calledFrom == VideosEditFormComponent){
          const type = fileToUpload.type
          const subtype = type.match(/video\/(.+)/)
          if( subtype)
          this.compressVideoFileAndUpload(fileToUpload, 0,urlData)
          else{
            const message = this.translate.instant("SnackBarConstants.UNSUPPORTED_FILE")
            this.commentService.addSnackBar.emit(message)
          }
  
        }else{
          if(this.data.supportedFileTypes.includes(fileToUpload.type))
            this.compressFileAndUpload(fileToUpload, 0,urlData)
          else{
            const message = this.translate.instant("SnackBarConstants.UNSUPPORTED_FILE")
            this.commentService.addSnackBar.emit(message)
          }
        }
      }
    }
    
  }

  ////-----------------
  async compressFileAndUpload(file, index, urlData){
    const fileToUpload = file;
    const maxSizeInBytes = this.maxSizeInBytes
    const maxAllowedSizeInBytes = this.maxAllowedSizeInBytes
  
    if (maxAllowedSizeInBytes && (fileToUpload.size > maxAllowedSizeInBytes)) {// File is too large for both upload and compression
      const message = this.translate.instant("SnackBarConstants.IMAGE_FILE_TOO_LARGE");
      this.commentService.addSnackBar.emit(message);
      return;
    }
  
    if (maxSizeInBytes && (fileToUpload.size > maxSizeInBytes)) {// File is between 2 MB and 20 MB, attempt compression
      try {
        const compressedImage = await this.imageCompressionService.compressImage(fileToUpload, maxSizeInBytes);
        if (!compressedImage) {
          const message = this.translate.instant("SnackBarConstants.IMAGE_TOO_LARGE");
          this.commentService.addSnackBar.emit(message);
          return;
        }else{
          await this.uploadFile(compressedImage, index, urlData)
        }
      } catch (error) {
        console.error("Compression error:", error);
        const message = this.translate.instant("SnackBarConstants.IMAGE_COMPRESSION_FAILED");
        this.commentService.addSnackBar.emit(message);
        return;
      }
    } else {// File is less than or equal to 2 MB, no compression needed
      await this.uploadFile(fileToUpload, index, urlData)
    }
  }


  async compressVideoFileAndUpload(file, index, urlData){
    const fileToUpload = file;
    const maxSizeInBytes = this.maxSizeInBytes
  
    if (file.size > maxSizeInBytes) {
      const message = this.translate.instant("SnackBarConstants.VIDEO_TOO_LARGE");
      this.commentService.addSnackBar.emit(message);
      return;
    } else {// File is less than or equal to 2 MB, no compression needed
      await this.uploadFile(fileToUpload, index, urlData)
    }
  }


  async uploadFile(file, index, urlData){
    try{
      const passId = this.data.calledFromData.passId
      const widgetNumber = this.data.calledFromData.widgetNumber
      this.commentService.progressSpin.emit(true)
    
      switch(this.data.calledFrom){
        case BillboardImgEditFormComponent:{
          
          const { newURL, filePath } = this.uploadService.buildFileWidgetUrl(passId, widgetNumber)
          this.uploadService.uploadFileOnPathURL(filePath, newURL, file).subscribe({
            next: (uploadURL) => {
              if (uploadURL) {
                this.url = uploadURL;
                this.urlData = urlData;
                this.dragFileBrowseForm.patchValue({returnUrlData: urlData, returnSupportUrl: uploadURL, returnUrlType: this.returnUrlType})
              }
            },
            error: (err) => console.log(err)
          });
          break;
        }
  
        case BillboardVdEditFormComponent:{
          await this.uploadService.uploadNewBillboardVideo(this.data.calledFromData.passId, [file], this.data.calledFromData.widgetNumber).then( uploadURL => {
            if (uploadURL) {
              this.url = uploadURL;
              this.urlData = urlData;
              this.dragFileBrowseForm.patchValue({returnUrlData: urlData, returnSupportUrl: uploadURL})
              this.commentService.progressSpin.emit(false)
              const message = this.translate.instant("SnackBarConstants.UPLOAD_FILE_OK")
              this.commentService.addSnackBar.emit(message)
            }
          })
          break;
        }
  
        case TextEditFormComponent:{

          const { newURL, filePath } = this.uploadService.buildFileWidgetUrl(passId, widgetNumber)
          this.uploadService.uploadFileOnPathURL(filePath, newURL, file).subscribe({
            next: (uploadURL) => {
              if (uploadURL) {
                this.url = uploadURL;
                this.urlData = urlData;
                this.dragFileBrowseForm.patchValue({returnUrlData: urlData, returnSupportUrl: uploadURL })
                this.uploadService.showMessageUploadSuccess()
              }
            },
            error: (err) => console.log(err)
          });

          break;
        }

        case ProductRegistrationEditFormComponent:{
          const { newURL, filePath } = this.uploadService.buildFileWidgetUrl(passId, widgetNumber)
          this.uploadService.uploadFileOnPathURL(filePath, newURL, file).subscribe({
            next: (uploadURL) => {
              if (uploadURL) {
                this.url = uploadURL;
                this.urlData = urlData;
                this.dragFileBrowseForm.patchValue({returnUrlData: urlData, returnSupportUrl: uploadURL, returnUrlType: this.returnUrlType})
                this.uploadService.showMessageUploadSuccess()
              }
            },
            error: (err) => console.log(err)
          });
          break;
        }

        // case ProductRegistrationEditFormComponent: {
        //   const uploadURL = await this.uploadService.uploadNewProductRegistrationImage(passId, file, widgetNumber);
        //   if (uploadURL) {
        //     this.url = uploadURL;
        //     this.urlData = urlData;
        //     this.dragFileBrowseForm.patchValue({returnUrlData: urlData, returnSupportUrl: uploadURL, returnUrlType: this.returnUrlType})
        //   }
        //   break;
        // }
  
        case VideoEditFormComponent:{
          await this.uploadService.uploadNewVideo(passId, [file], widgetNumber).then( uploadURL => {
            if (uploadURL) {
              this.url = uploadURL;
              this.urlData = urlData;
              this.dragFileBrowseForm.patchValue({returnUrlData: urlData, returnSupportUrl: uploadURL, returnUrlType: this.returnUrlType})
              this.commentService.progressSpin.emit(false)
              const message = this.translate.instant("SnackBarConstants.UPLOAD_FILE_OK")
              this.commentService.addSnackBar.emit(message)
            }
          })
          break;
        }
  
        case SplashVideoEditFormComponent:{
          await this.uploadService.uploadNewSplashVideo(this.data.calledFromData.passId, [file], this.data.calledFromData.widgetNumber).then( uploadURL => {
            if (uploadURL) {
              this.url = uploadURL
              this.urlData = urlData
              this.dragFileBrowseForm.patchValue({returnUrlData: urlData, returnSupportUrl: uploadURL})
              this.commentService.progressSpin.emit(false)
              const message = this.translate.instant("SnackBarConstants.UPLOAD_FILE_OK")
              this.commentService.addSnackBar.emit(message)
            }
          })          

          break;
        }

        case VideosEditFormComponent:{
          await this.uploadService.uploadNewVideo(passId, [file], widgetNumber).then( uploadURL => {
            if (uploadURL) {
              //console.log(uploadURL)
              this.url = uploadURL
              this.urlData = urlData
              this.dragFileBrowseForm.patchValue({returnUrlData: urlData, returnSupportUrl: uploadURL})
              this.commentService.progressSpin.emit(false)
              const message = this.translate.instant("SnackBarConstants.UPLOAD_FILE_OK")
              this.commentService.addSnackBar.emit(message)
            }
          })          

          break;
        }

        case ImageEditFormComponent:{
          const { newURL, filePath } = this.uploadService.buildFileWidgetUrl(passId, widgetNumber)
          this.uploadService.uploadFileOnPathURL(filePath, newURL, file).subscribe({
            next: (uploadURL) => {
              if (uploadURL) {
                this.url = uploadURL;
                this.urlData = urlData;
                this.dragFileBrowseForm.patchValue({returnUrlData: urlData, returnSupportUrl: uploadURL})
                this.uploadService.showMessageUploadSuccess()
              }
            },
            error: (err) => console.log(err)
          });

          break;
        }
  
        case ImagesEditFormComponent:{
          const uploadURL = await this.uploadService.uploadNewImages(passId, file, index, widgetNumber);
          if (uploadURL) {
            this.url = uploadURL;
            this.urlData = urlData;
            this.dragFileBrowseForm.patchValue({returnUrlData: urlData, returnSupportUrl: uploadURL, returnUrlType: this.returnUrlType})
          }
          break;
        }


        case CalltoactionEditFormComponent :{
          const { newURL, filePath } = this.uploadService.buildFileWidgetUrl(passId, widgetNumber)
          this.uploadService.uploadFileOnPathURL(filePath, newURL, file).subscribe({
            next: (uploadURL) => {
              if (uploadURL) {
                this.url = uploadURL;
                this.urlData = urlData;
                this.dragFileBrowseForm.patchValue({returnUrlData: urlData, returnSupportUrl: uploadURL, returnUrlType: this.returnUrlType})
              }
            },
            error: (err) => console.log(err)
          });
          break;
        }

        case TaskTemplateFieldDialogComponent :{
          const uploadURL = await this.uploadService.uploadWorkTaskImgae(this.settingsService.contextId$,this.data.calledFromData.taskId, file, this.data.calledFromData.sectionIndex, this.data.calledFromData.fieldIndex);
          if(uploadURL){
            this.urlData = urlData;
            this.dragFileBrowseForm.patchValue({returnUrlData: urlData, returnSupportUrl: uploadURL, returnUrlType: this.returnUrlType})
          }
          break;
        }
    
      }

      if(this.data.calledFrom != TextEditFormComponent && this.data.calledFrom != BillboardImgEditFormComponent 
        && this.data.calledFrom != ImageEditFormComponent && this.data.calledFrom != CalltoactionEditFormComponent 
        && this.data.calledFrom != ProductRegistrationEditFormComponent && this.data.calledFrom != SplashVideoEditFormComponent
        && this.data.calledFrom != VideoEditFormComponent && this.data.calledFrom != VideosEditFormComponent
      ){
        setTimeout(() =>{
          //console.log('--timeout--')
          this.commentService.progressSpin.emit(false)
          const message = this.translate.instant("SnackBarConstants.UPLOAD_FILE_OK")
          this.commentService.addSnackBar.emit(message)
        }, 800);
      }
      
    }catch(error){
      console.log(error)
      const message = this.translate.instant("SnackBarConstants.UPLOAD_IMG_FAILED")
      this.commentService.addSnackBar.emit(message)
    }
  }

  get checkLicenseFree(): boolean{
    return this.contextLicenseFree ? true : false
  }

}
